export default __webpack_public_path__ + "static/media/success.ea5ee80e.svg";